export default function menuToggle() {
    const navBtn = jQuery('.hamburger');
    const menu = jQuery('nav');
    const menuItem = jQuery('.menu-item a');

    navBtn.on('click', function () {
        jQuery(this).toggleClass('is-active');
        menu.slideToggle('slow');
    });

    menuItem.on('click', function () {
        menu.slideToggle('slow');
        navBtn.removeClass('is-active');
    });
}
